<div class="ap">
  <h1 class="ap__title">{{ i18n.t('auth.welcome') }}</h1>
  <p class="ap__sub">{{ i18n.t('auth.signUpOrLogIn') }}</p>

  <!-- Validation / status messages, kept at the top so they're always visible (the forms can be tall). -->
  @if (error()) { <p class="ap__error">{{ error() }}</p> }
  @if (info()) { <p class="ap__info">{{ info() }}</p> }

  @if (showSocial() && mode() !== 'code' && mode() !== 'verify' && mode() !== 'forgot' && mode() !== 'forgot-verify') {
    <div class="ap__social">
      @if (social.facebookEnabled) {
        <button type="button" class="ap__fb" (click)="continueWithFacebook()" [disabled]="socialLoading()">
          <span class="ap__fb-icon" aria-hidden="true">f</span>
          Continue with Facebook
        </button>
      }
      @if (social.googleEnabled) {
        <!-- Google Identity Services renders its button here. -->
        <div #googleBtn class="ap__google"></div>
      }
    </div>

    <div class="ap__or"><span>or</span></div>
  }

  @if (mode() === 'welcome') {
    <label class="ap__label" for="ap-email">{{ i18n.t('auth.email') }}</label>
    <input
      id="ap-email"
      class="ap__input"
      type="email"
      inputmode="email"
      autocomplete="email"
      [placeholder]="i18n.t('auth.emailPlaceholder')"
      [(ngModel)]="email"
      (keyup.enter)="sendEmailCode()"
    />
    <button type="button" class="ap__primary" (click)="sendEmailCode()" [disabled]="loading()">
      {{ loading() ? 'Sending…' : 'Continue with email' }}
    </button>
    <div class="ap__alt">
      <button type="button" class="ap__link" (click)="showLogin()">{{ i18n.t('auth.logInWithPassword') }}</button>
      <span class="ap__alt-sep">·</span>
      <button type="button" class="ap__link" (click)="showSignup()">{{ i18n.t('auth.createAccount') }}</button>
    </div>
  } @else if (mode() === 'code') {
    <p class="ap__codehint">{{ i18n.t('auth.codeSentTo', { email: email }) }}</p>
    <input
      class="ap__input ap__input--code"
      type="text"
      inputmode="numeric"
      maxlength="6"
      autocomplete="one-time-code"
      placeholder="——————"
      [(ngModel)]="code"
      (keyup.enter)="verifyEmailCode()"
    />
    <button type="button" class="ap__primary" (click)="verifyEmailCode()" [disabled]="loading()">
      {{ loading() ? 'Verifying…' : 'Verify & continue' }}
    </button>
    <button type="button" class="ap__link" (click)="changeEmail()">{{ i18n.t('auth.useDifferentEmail') }}</button>
  } @else if (mode() === 'verify') {
    <p class="ap__codehint">{{ i18n.t('auth.verifyEmailTo', { email: email }) }}</p>
    <input
      class="ap__input ap__input--code"
      type="text"
      inputmode="numeric"
      maxlength="6"
      autocomplete="one-time-code"
      placeholder="——————"
      [(ngModel)]="code"
      (keyup.enter)="verifySignupCode()"
    />
    <button type="button" class="ap__primary" (click)="verifySignupCode()" [disabled]="loading()">
      {{ loading() ? 'Verifying…' : 'Verify & create account' }}
    </button>
    <div class="ap__alt">
      <button type="button" class="ap__link" (click)="resendSignupCode()" [disabled]="loading() || resendIn() > 0">
        {{ resendIn() > 0 ? 'Resend code in ' + resendIn() + 's' : 'Resend code' }}
      </button>
      <span class="ap__alt-sep">·</span>
      <button type="button" class="ap__link" (click)="backToSignup()">{{ i18n.t('common.back') }}</button>
    </div>
  } @else if (mode() === 'login') {
    <label class="ap__label" for="ap-login-email">{{ i18n.t('auth.email') }}</label>
    <input id="ap-login-email" class="ap__input" type="email" inputmode="email" autocomplete="email" [placeholder]="i18n.t('auth.emailPlaceholder')" [(ngModel)]="email" />
    <label class="ap__label" for="ap-login-pwd">{{ i18n.t('auth.password') }}</label>
    <input id="ap-login-pwd" class="ap__input" type="password" autocomplete="current-password" placeholder="••••••••" [(ngModel)]="password" (keyup.enter)="doLogin()" />
    <button type="button" class="ap__primary" (click)="doLogin()" [disabled]="loading()">
      {{ loading() ? 'Signing in…' : 'Log in' }}
    </button>
    <div class="ap__alt">
      <button type="button" class="ap__link" (click)="showForgot()">{{ i18n.t('auth.forgotPassword') }}</button>
    </div>
    <div class="ap__alt">
      <button type="button" class="ap__link" (click)="showSignup()">{{ i18n.t('auth.createAccount') }}</button>
      <span class="ap__alt-sep">·</span>
      <button type="button" class="ap__link" (click)="backToWelcome()">{{ i18n.t('auth.otherWays') }}</button>
    </div>
  } @else if (mode() === 'forgot') {
    <p class="ap__codehint">{{ i18n.t('auth.resetLead') }}</p>
    <label class="ap__label" for="ap-fp-email">{{ i18n.t('auth.email') }}</label>
    <input id="ap-fp-email" class="ap__input" type="email" inputmode="email" autocomplete="email" [placeholder]="i18n.t('auth.emailPlaceholder')" [(ngModel)]="email" (keyup.enter)="sendResetCode()" />
    <button type="button" class="ap__primary" (click)="sendResetCode()" [disabled]="loading()">
      {{ loading() ? 'Sending…' : 'Send reset code' }}
    </button>
    <button type="button" class="ap__link" (click)="showLogin()">{{ i18n.t('auth.backToLogIn') }}</button>
  } @else if (mode() === 'forgot-verify') {
    <p class="ap__codehint">{{ i18n.t('auth.resetCodeSentTo', { email: email }) }}</p>
    <label class="ap__label" for="ap-fp-code">{{ i18n.t('auth.resetCode') }}</label>
    <input id="ap-fp-code" class="ap__input ap__input--code" type="text" inputmode="numeric" maxlength="6" autocomplete="one-time-code" placeholder="——————" [(ngModel)]="code" (keyup.enter)="verifyResetCode()" />
    <button type="button" class="ap__primary" (click)="verifyResetCode()" [disabled]="loading()">
      {{ loading() ? 'Verifying…' : 'Verify code' }}
    </button>
    <button type="button" class="ap__link" (click)="showForgot()">{{ i18n.t('auth.useDifferentEmail') }}</button>
  } @else if (mode() === 'forgot-reset') {
    <p class="ap__codehint">{{ i18n.t('auth.chooseNewFor', { email: email }) }}</p>
    <label class="ap__label" for="ap-fp-pwd">{{ i18n.t('auth.newPassword') }}</label>
    <input id="ap-fp-pwd" class="ap__input" type="password" autocomplete="new-password" [placeholder]="i18n.t('auth.passwordPlaceholder')" [(ngModel)]="newPassword" (keyup.enter)="resetPassword()" />
    <label class="ap__label" for="ap-fp-pwd2">{{ i18n.t('auth.confirmPassword') }}</label>
    <!-- Its OWN field, not the sign-up form's confirmPassword. Sharing it looked harmless but leaks:
         showForgot() clears newPassword and not confirmPassword, so a half-filled sign-up would leave
         a stale value sitting in this box — masked, therefore invisible — and the shopper would face a
         mismatch they cannot see, or a match they never actually confirmed. -->
    <input id="ap-fp-pwd2" class="ap__input" type="password" autocomplete="new-password" [placeholder]="i18n.t('auth.confirmPlaceholder')" [(ngModel)]="confirmNewPassword" (keyup.enter)="resetPassword()" />
    <!-- Live inline feedback as they type, matching the sign-up form above: a typo in a masked field
         is invisible, and being told after the request has gone is too late — the reset code is
         single-use. Held back until the box has something in it so it cannot fire on keystroke one. -->
    @if (confirmNewPassword && newPassword !== confirmNewPassword) {
      <p class="ap__error">{{ i18n.t('auth.passwordsMismatch') }}</p>
    }
    <button type="button" class="ap__primary" (click)="resetPassword()" [disabled]="loading()">
      {{ loading() ? 'Updating…' : 'Set new password' }}
    </button>
  } @else {
    <label class="ap__label" for="ap-su-name">{{ i18n.t('auth.fullName') }}</label>
    <input id="ap-su-name" class="ap__input" type="text" autocomplete="name" [placeholder]="i18n.t('auth.namePlaceholder')" [(ngModel)]="displayName" />
    <label class="ap__label" for="ap-su-email">{{ i18n.t('auth.email') }}</label>
    <input id="ap-su-email" class="ap__input" type="email" inputmode="email" autocomplete="email" [placeholder]="i18n.t('auth.emailPlaceholder')" [(ngModel)]="email" />
    <label class="ap__label" for="ap-su-phone">{{ i18n.t('auth.phoneNumber') }} {{ i18n.t('location.optional') }}</label>
    <!-- The shared field, not a free-text box: it publishes E.164 (+92 300 4197674) or nothing, which
         matters more than it looks. The API only stores a sign-up phone that normalises to E.164, so a
         typed "03004197674" used to be dropped on the floor without a word; and placing an order now
         copies the number onto the account as its sign-in identifier, so a mistyped one is not just an
         unreachable contact but an account its owner cannot be found by. -->
    <app-phone-field [(value)]="phone" [required]="false" [forceValidate]="phoneTouched" inputId="ap-su-phone" />
    <label class="ap__label" for="ap-su-pwd">{{ i18n.t('auth.password') }}</label>
    <input id="ap-su-pwd" class="ap__input" type="password" autocomplete="new-password" [placeholder]="i18n.t('auth.passwordPlaceholder')" [(ngModel)]="password" />
    <label class="ap__label" for="ap-su-cpwd">{{ i18n.t('auth.confirmPassword') }}</label>
    <input id="ap-su-cpwd" class="ap__input" type="password" autocomplete="new-password" [placeholder]="i18n.t('auth.confirmPlaceholder')" [(ngModel)]="confirmPassword" (keyup.enter)="doSignup()" />
    <!-- Live inline feedback right below the fields, as the user types. -->
    @if (confirmPassword && password !== confirmPassword) {
      <p class="ap__error">{{ i18n.t('auth.passwordsMismatch') }}</p>
    }
    <button type="button" class="ap__primary" (click)="doSignup()" [disabled]="loading()">
      {{ loading() ? 'Creating…' : 'Create account' }}
    </button>
    <div class="ap__alt">
      <button type="button" class="ap__link" (click)="showLogin()">{{ i18n.t('auth.haveAccount') }}</button>
      <span class="ap__alt-sep">·</span>
      <button type="button" class="ap__link" (click)="backToWelcome()">{{ i18n.t('auth.otherWays') }}</button>
    </div>
  }

  @if (socialLoading()) { <p class="ap__info">{{ i18n.t('auth.signingIn') }}</p> }

  <!-- Absolute, not relative: these pages live on the marketing site, which is a different origin
       now that the storefront has its own domain. Same convention as stores-page's getAppUrl. -->
  <p class="ap__terms">
    By continuing, you agree to our <a href="https://www.orderyaa.com/privacy-policy" target="_blank" rel="noopener">{{ i18n.t('auth.terms') }}</a>
    and <a href="https://www.orderyaa.com/privacy-policy" target="_blank" rel="noopener">{{ i18n.t('auth.privacy') }}</a>.
  </p>
</div>
